import React from 'react'

function UpdateClaimedShift() {
  return (
    <div>UpdateClaimedShift</div>
  )
}

export default UpdateClaimedShift